import React, { useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import DetailCard from '../../../shared/components/v3/Cards/DetailCard/DetailCard';
import StepsCard from '../../../shared/components/v3/Cards/StepsCard/StepsCard';
import { METRICS_NE_ROUTE, PLAN_ROUTE } from '../../../shared/constants/auth';
import { TRANSLATIONS_BENEFIT_CATEGORIES, BENEFIT_REWARDS_SKU } from '../../../shared/constants/benefits';
import { NORTH_EAST_ARROW } from '../../../shared/constants/images';
import { CompanyContext } from '../../../shared/context/company/companyContext';
import { PlansContext } from '../../../shared/context/plans/plansContext';
import { useBenefitDetail } from '../../../shared/hooks/useBenefitDetail/useBenefitDetail';
import { useBenefitInsight } from '../../../shared/hooks/useBenefitInsight/useBenefitInsight';
import { TRANSLATION_MY_PLAN } from '../../../shared/translations/plan';
import { categoryKeys } from '../../../shared/types/benefitTypes';
import DetailHeader from '../DetailHeader/DetailHeader';

import './BenefitDetail.scss';

const BenefitDetail = () => {
  const { company } = useContext(CompanyContext);
  const { selectedBenefit } = useContext(PlansContext);

  const { t } = useTranslation();
  const navigate = useNavigate();

  const {
    benefit,
    loading: loadingDetail,
    error: errorDetail,
    refetch: refetchDetail
  } = useBenefitDetail(company.id, selectedBenefit?.benefitId ?? '');

  const {
    intendedUses,
    loading: loadingInsight,
    error: errorInsight,
    refetch: refetchInsight
  } = useBenefitInsight(company.id, selectedBenefit?.benefitId ?? '');

  const redirectToMetrics = () => {
    navigate(`${METRICS_NE_ROUTE}?type=benefits`);
  };

  return (
    <div className="plan-benefit-container" data-experience="new">
      <DetailHeader
        title={selectedBenefit?.title ?? ''}
        tag={
          selectedBenefit?.category ? t(TRANSLATIONS_BENEFIT_CATEGORIES[selectedBenefit.category as categoryKeys]) : ''
        }
        tagVariant="fill"
        tagColor="fill-primary"
        backAction={() => navigate(PLAN_ROUTE)}
      />
      <div className="pb-content p-6 gap-8">
        <div className="pb-benefit-info">
          <DetailCard
            title={benefit?.title ?? ''}
            icon={benefit?.icon}
            description={benefit?.description}
            type="detail"
            loading={loadingDetail}
            error={errorDetail}
            retry={refetchDetail}
          />
        </div>
        {selectedBenefit?.sku?.toLowerCase() !== BENEFIT_REWARDS_SKU && (
          <div className="pb-benefit-insight">
            <DetailCard
              title={t(TRANSLATION_MY_PLAN.cards.insight.title, { number: intendedUses, count: intendedUses })}
              description={t(TRANSLATION_MY_PLAN.cards.insight.description)}
              type="insight"
              action={redirectToMetrics}
              iconButton={NORTH_EAST_ARROW}
              loading={loadingInsight}
              error={errorInsight}
              retry={refetchInsight}
            />
          </div>
        )}
        <div className="pb-benefit-usage">
          <StepsCard
            title={t(TRANSLATION_MY_PLAN.instructionTitle)}
            steps={benefit?.steps ?? []}
            loading={loadingDetail}
            error={errorDetail}
            retry={refetchDetail}
          />
        </div>
      </div>
    </div>
  );
};

export default BenefitDetail;
